import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import countries from '../../data/CountryList'; // countries = {us: "United States", ...}

const Container = styled.div`
  position: relative;
  width: auto;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;

`;

const SuggestionsList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  border: 1px solid #ccc;
  border-top: none;
  max-height: 150px;
  overflow-y: auto;
  background-color: #fff;
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  z-index: 1000;
`;

const Suggestion = styled.li`
  padding: 8px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;

const AutoComplete = ({ setType }) => {
  const [query, setQuery] = useState('Cameroon');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const containerRef = useRef(null);

  const countryEntries = Object.entries(countries); // [ ['us', 'United States'], ... ]

  const filteredSuggestions = query === ''
    ? countryEntries
    : countryEntries.filter(([_, name]) =>
        name.toLowerCase().startsWith(query.toLowerCase())
      );

  // Обновить parent компонент при изменении query
  useEffect(() => {
    const match = countryEntries.find(([_, name]) =>
      name.toLowerCase() === query.toLowerCase()
    );
    if (match) {
      setType(match[0]); // передаём код страны
    }
  }, [query]);

  // Закрытие по клику вне
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleChange = (e) => {
    setQuery(e.target.value);
    setShowSuggestions(true);
  };

  const handleClickSuggestion = ([code, name]) => {
    setQuery(name); 
    setShowSuggestions(false); 
    setType(code);
  };

  return (
    <Container ref={containerRef} style={{marginBottom: 10, marginTop: 10, fontSize: 18}}>
      <Input
        type="text"
        value={query}
        onChange={handleChange}
        style={{fontSize: 18}}
        onFocus={() => setShowSuggestions(true)}
        placeholder="Select country"
      />
      {showSuggestions && filteredSuggestions.length > 0 && (
        <SuggestionsList>
          {filteredSuggestions.map(([code, name]) => (
            <Suggestion key={code} onClick={() => handleClickSuggestion([code, name])}>
              {name}
            </Suggestion>
          ))}
        </SuggestionsList>
      )}
    </Container>
  );
};

export default AutoComplete;
